import { render } from "./Link.vue?vue&type=template&id=ebe5f80a&scoped=true"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"

import "./Link.vue?vue&type=style&index=0&id=ebe5f80a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebe5f80a"]])

export default __exports__